import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/:catchAll(.*)',
    redirect: '/404'
  },
  {
    path: '/404',
    name: '404',
    component: ()=> import('@/views/ErrorPage.vue')
  },
  {
    path:'/real-auth',
    name:'real-auth',
    meta: { title: '实名认证' },
    component: ()=>import('@/views/auth/RealNameAuthPage.vue')
  },
  {
    path:'/signature',
    name:'signature',
    meta: { title: '手写签名' },
    component: ()=>import('@/views/other/SignaturePage.vue')
  },
  {
    path:'/person-cer-pay',
    name:'person-cer-pay',
    meta: { title: '确认订单' },
    component: ()=>import('@/views/cer/person/PersonCerPayPage.vue')
  },
  {
    path:'/company-cer-pay',
    name:'company-cer-pay',
    component: ()=>import('@/views/cer/company/CompanyCerPayPage.vue')
  },
  {
    path:'/shuanglu-callback/:orderUuid?',
    name:'shuanglu-callback',
    meta: { title: '双录认证' },
    component: ()=>import('@/views/cer/ShuangluCallbackPage.vue')
  },
  {
    path:'/auth-result',
    name:'auth-result',
    component: ()=>import('@/views/auth/AuthResultPage.vue')
  },
  {
    path:'/agreement',
    name:'agreement',
    meta: { title: '协议' },
    component: ()=>import('@/views/agreement/AgreementPage.vue')
  },
  {
    path:'/ower-identify/:id',
    name:'identify',
    meta: { title: '管理员权限转让确认' },
    component: ()=>import('@/views/other/OwerIdentifyPage.vue')
  },
  {
    path:'/ower-identify-result/:id',
    name:'identifyResult',
    component: ()=>import('@/views/other/OwerIdentifyResultPage.vue')
  },
  {
    path:'/manage-transfer',
    name:'transfer',
    component: ()=>import('@/views/other/ManageTransferConfirmPage.vue')
  },
  {
    path:'/legal-confirm',
    name:'legalconfirm',
    component: ()=>import('@/views/other/legalConfirmResultPage.vue')
  },
  {
    path:'/agreements/yintongbao/user_agreement',
    name:'userAgreement',
    component: ()=>import('@/views/agreements/yintongbao/UserAgreement.vue')
  },
  {
    path:'/agreements/yintongbao/privacy_policy',
    name:'privacyPolicy',
    component: ()=>import('@/views/agreements/yintongbao/PrivacyPolicy.vue')
  },
  {
    path:'/agreements/yintongbao/personal_info_list',
    name:'PersonalInfoList',
    component: ()=>import('@/views/agreements/yintongbao/PersonalInfoList.vue')
  },
  {
    path:'/agreements/yintongbao/third_party_sdk_list',
    name:'ThirdPartySdkList',
    component: ()=>import('@/views/agreements/yintongbao/ThirdPartySdkList.vue')
  },
  {
    path:'/agreements/yintongbao/app_permissions',
    name:'AppPermissions',
    component: ()=>import('@/views/agreements/yintongbao/AppPermissions.vue')
  },
  {
    path:'/agreements/yibiaoqian/user_agreement',
    name:'userAgreementybq',
    component: ()=>import('@/views/agreements/yibiaoqian/YBQUserAgreement.vue')
  },
  {
    path:'/agreements/yibiaoqian/privacy_policy',
    name:'privacyPolicyybq',
    component: ()=>import('@/views/agreements/yibiaoqian/YBQPrivacyPolicy.vue')
  },
  {
    path:'/agreements/yibiaoqian/personal_info_list',
    name:'PersonalInfoListybq',
    component: ()=>import('@/views/agreements/yibiaoqian/YBQPersonalInfoList.vue')
  },
  {
    path:'/agreements/yibiaoqian/third_party_sdk_list',
    name:'ThirdPartySdkListybq',
    component: ()=>import('@/views/agreements/yibiaoqian/YBQThirdPartySdkList.vue')
  },
  {
    path:'/agreements/yibiaoqian/app_permissions',
    name:'AppPermissionsybq',
    component: ()=>import('@/views/agreements/yibiaoqian/YBQAppPermissions.vue')
  },
  {
    path:'/agreements/yibiaoqian/cert_user_notice',
    name:'CertUserNoticeybq',
    component: ()=>import('@/views/agreements/yibiaoqian/YBQCertUserNotice.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 全局守卫，设置文档标题
router.beforeEach((to, from, next) => {
  const title = to.meta.title || '　'; // 获取标题
  document.title = title; // 设置标题
  next(); // 继续导航
});


export default router
